<!-- <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template> -->

<div class="grid align-items-center">
  <div class="col md:col-12">
    <span class="p-input-icon-left ml-auto w-full">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        class="w-full"
        #keywordFilter
        (input)="dt1.filterGlobal([keywordFilter.value], '')"
        placeholder="Cerca..." />
    </span>
  </div>
</div>

<div class="tbl max-w-full">
  <p-table
    [paginator]="true"
    [value]="availableWorkflows"
    #dt1
    [rows]="25"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [lazy]="true"
    [loading]="loading"
    (onLazyLoad)="getWorkflows(tipoWF!, $event)"
    [(selection)]="selectedWorkflow"
    dataKey="id"
    [totalRecords]="totalRecords"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali">
    <ng-template pTemplate="header">
      <tr class="tHead">
        <th></th>
        <th>Nome</th>
        <th>Descrizione</th>
        <th>Azienda</th>
        <th>Ordine</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-wf>
      <tr>
        <td>
          <p-tableRadioButton [value]="wf" />
        </td>
        <td>{{ wf.name }}</td>
        <td>{{ wf.description }}</td>
        <td>{{ wf.related_agreement?.identifier }}</td>
        <td>{{ wf.related_orders?.identifier }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          colspan="5"
          class="text-center py-2">
          Nessun risultato.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      icon="pi pi-times"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      icon="pi pi-check"
      (onClick)="save()"
      styleClass="butt"
      [rounded]="true"></p-button>
  </div>
</div>

<!-- <pre>{{ selectedWorkflow | json }}</pre> -->
